import React, { Component, Fragment } from 'react';
import { withMixpanel } from '../context/mixPanelContext';
import { Link } from 'react-router-dom';

import {
  object,
  string
} from 'yup';

import {
  Container,
  Typography,
  Grid,
} from '@material-ui/core';

import { ArrowBack } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';

import FormContainer from '../components/FormContainer';
import Faqs from '../components/Faqs';
import OrderForm from '../layouts/OrderForm';
import Quote from '../layouts/Quote';
import { createOrder } from '../utils/fetch';
import { STRIPE_TOKEN_US, STRIPE_TOKEN_CA, HVAC_MONITORING } from '../utils/const.js.erb';
import { commonStyles } from '../styles';
import Logo from '../components/Logo';
import { paramFromQueryString } from '../utils';

const styles = theme => ({
  ...commonStyles(theme),
  link: {
    display: 'inline-block',
    textDecoration: 'none',
    marginBottom: theme.spacing(2),
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.secondary,
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '16px',
    },
  },
  formContainer: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing(7)
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: 0,
      paddingRight: theme.spacing(3)
    }
  }
});

const OrderSchema = object({
  address: object({
    address1: string()
      .required('Required'),
    city: string()
      .required('Required'),
    zipcode: string()
      .matches(/^(\d{5}|\w{3}( \w{3})?)$/, 'Zip Code is not valid')
      .required('Required'),
    state: string()
      .required('Required')
  })
});

class Checkout extends Component {
  state = {
    stripe: null,
    terms: false
  };

  handleShownTrack = () => {
    const { mixpanel, service, quote, user } = this.props;
    const { zipcode, email } = user;
    const { service_name} = quote;
    const { product_sku } = service;
    mixpanel.tracker('payment_shown', {
      product_sku,
      service_name,
      email,
      product_type:'consumer',
      zip_code: zipcode,
    });
  }

  handleSubmitTrack = (data) => {
    const { mixpanel, quote } = this.props;
    const { user, service } = data;
    const { product_sku, third_party_allowed } = service;
    const { zipcode, email } = user;
    const { service_name, starts_at} = quote;

    mixpanel.tracker('payment_submitted', {
      zip_code: zipcode,
      product_type:'consumer',
      third_party_allowed,
      starts_at,
      product_sku,
      email,
      service_name,
    });
  }

  handlePaymentErrorTrack = (data, err) => {
    const { mixpanel, quote } = this.props;
    const { user, service } = data;
    const { product_sku, third_party_allowed } = service;
    const { zipcode, email } = user;
    const { service_name, starts_at} = quote;

    mixpanel.tracker('payment_error', {
      zip_code: zipcode,
      product_type:'consumer',
      third_party_allowed,
      starts_at,
      product_sku,
      email,
      service_name,
      error_info: JSON.parse(err.message).toString(),
    });
  }

  componentDidMount() {
    const { country } = this.props.address;

    this.handleShownTrack();

    if (window.Stripe) {
      this.setState({stripe: window.Stripe(this.stripeTokenForCountry(country))});
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        this.setState({stripe: window.Stripe(this.stripeTokenForCountry(country))});
      });
    }
  }

  stripeTokenForCountry = (country) => {
    return country === 'CA' ? STRIPE_TOKEN_CA : STRIPE_TOKEN_US;
  };

  handleSubmit = async values => {
    const issueType = paramFromQueryString(this.props.location.search, 'issue_type');
    const deliveryType = paramFromQueryString(this.props.location.search, 'delivery_type');
    const nestProId = paramFromQueryString(this.props.location.search, 'nest_pro_id');
    const issueId = paramFromQueryString(this.props.location.search, 'issue_id');

    const {
      service,
      user,
      address,
      startLoading,
      stopLoading,
      updateFormInput,
      updateOrder,
      showError,
      hideError,
      onBehalfOfPartnerMachineName
    } = this.props;

    startLoading();
    hideError();

    const data = {
      service,
      user: {
        ...user,
        stripe_token: values.user.stripe_token,
      },
      address: {
        ...address,
        address1: values.address.address1,
        city: values.address.city,
        zipcode: values.address.zipcode,
        state: values.address.state,
      },
      issue_id: issueId,
      issue_type: issueType,
      delivery_type: deliveryType,
      nest_pro_id: nestProId,
      on_behalf_of_partner_machine_name: onBehalfOfPartnerMachineName
    }

    try {
      const res = await createOrder(data);
      const order = res.data.order;
      updateFormInput(values);
      updateOrder(order);
      this.nextPage(order);
      this.handleSubmitTrack(data);
    } catch(error) {
      showError(error);
      this.handlePaymentErrorTrack(data, error)
    } finally {
      stopLoading();
    }
  }

  toggleTerms = () => {
    this.setState({terms: !this.state.terms ? true : false});
  }

  nextPage(order) {
    const { search } = this.props.location;
    const partnerOrderId = order.partner_order_id;
    this.props.history.push(`/confirmation/${partnerOrderId}${search}`);
  }

  render() {
    const { partnerOrderId } = this.props.match.params;
    const { stripe, terms } = this.state;

    const {
      service,
      address,
      quote,
      isLoading,
      errorMessage,
      classes,
      width,
      systemType
    } = this.props;

    const initialValues = {
      user: {
        stripe_token: '',
      },
      address
    };

    return (
      <Fragment>
        <Container className={classes.container}>
          <Grid container>
            <Grid item xs={12}>
              <div className={classes.header}>
                <Logo partnerOrderId={partnerOrderId} />
                <Typography variant="h1" gutterBottom>Checkout</Typography>
              </div>
              <Link className={classes.link} to={partnerOrderId ? `/${HVAC_MONITORING}/${partnerOrderId}` : `/${HVAC_MONITORING}`}>
                <Grid container alignItems="center">
                  <ArrowBack />
                  <Typography variant="subtitle1" color="textSecondary">Service Details</Typography>
                </Grid>
              </Link>
              <Grid container direction={isWidthUp('md', width) ? 'row' : 'column-reverse'}>
                <Grid className={classes.formContainer} item xs={12} md={8}>
                  <FormContainer
                    initialValues={initialValues}
                    validationSchema={OrderSchema}
                    handleSubmit={this.handleSubmit}
                  >
                    <OrderForm
                      isLoading={isLoading}
                      errorMessage={errorMessage}
                      classes={classes}
                      stripe={stripe}
                      terms={terms}
                      toggleTerms={this.toggleTerms}
                    />
                  </FormContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Quote
                    service={service}
                    quote={quote}
                    systemType={systemType}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Faqs />
      </Fragment>
    );
  }
}

export default withStyles(styles)(withWidth()(withMixpanel(Checkout)));
